import React from "react";
import styles from "../AddEditAutoImportConfigurationsModal.module.css";
import { LRequiredInput } from "./CommonComponents/LRequiredInput";
import { FormGrid } from "./CommonComponents/FormGrid";
import { useAutoImportFormContext } from "../../Context/AutoImportFormContext";

function ValidationsForm() {
  const { formData, updateStepData } = useAutoImportFormContext();
  const { validations } = formData;

  const inputs = [
    {
      colSpan: 6,
      render: () => (
        <div className={styles.checkboxInputAlign}>
          <LRequiredInput
            type="checkbox"
            required
            labelName="Validate Repeated File Name"
            checkbox={{
              value: validations.validateRepeatedFileName,
              checked: validations.validateRepeatedFileName,
              onChange: (e: any) => updateStepData("validations", {validateRepeatedFileName: e.value}),
            }}
          />
        </div>
      ),
    },
    {
      colSpan: 6,
      render: () => (
        <div className={styles.checkboxInputAlign}>
          <LRequiredInput
            type="checkbox"
            required
            labelName="Validate Repeated Checksum"
            checkbox={{
              value: validations.validateRepeatedChecksum,
              checked: validations.validateRepeatedChecksum,
              onChange: (e: any) => updateStepData("validations", {validateRepeatedChecksum: e.value}),
            }}
          />
        </div>
      ),
    },
  ];

  return <FormGrid items={inputs} />;
}
export { ValidationsForm };
